import React from "react"
import { useInscriptionFunnel } from "./context/InscriptionFunnelContext"
import FunnelAppDownload from "../brevet/components/FunnelAppDownload"

/**
 * Dernier écran du funnel : « installez l'app ». Strictement le même que celui
 * de l'été et du stage — le composant partagé porte tout le contenu, ce wrapper
 * ne fait que lui donner le prénom et la source de tracking.
 */
const InscriptionAppDownloadScreen = () => {
    const { state } = useInscriptionFunnel()

    return (
        <FunnelAppDownload
            firstname={state.studentFirstname}
            trackingSource="inscription_download_app"
            hideLogo
        />
    )
}

export default InscriptionAppDownloadScreen
